import { flagIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Flag = createIcon({
  displayName: 'Flag',
  paths: [
    'M256 512v-384c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v42.667h426.667c47.104 0 85.333 38.229 85.333 85.333v256c0 47.104-38.229 85.333-85.333 85.333h-426.667v256h42.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-170.667c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h42.667v-341.333zM341.333 256v256h426.667v-256h-426.667z'
  ],
  canvasPaths: canvasIconPaths(flagIcon)
})
